import { useState, useEffect } from 'react';

export default function CountdownTimer({ endTime, onExpire }) {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const now = new Date().getTime();
    const target = endTime || getEndOfDay();
    const difference = target - now;

    if (difference <= 0) {
      return { hours: 0, minutes: 0, seconds: 0, expired: true };
    }

    return {
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / (1000 * 60)) % 60),
      seconds: Math.floor((difference / 1000) % 60),
      expired: false,
    };
  }

  function getEndOfDay() {
    const now = new Date();
    const endOfDay = new Date(now);
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay.getTime();
  }

  useEffect(() => {
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      
      if (newTimeLeft.expired && onExpire) {
        onExpire();
        clearInterval(timer);
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [endTime, onExpire]);

  const formatNumber = (num) => String(num).padStart(2, '0');

  if (timeLeft.expired) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-2" data-testid="countdown-timer">
      <TimeBlock value={formatNumber(timeLeft.hours)} label="HRS" />
      <span className="text-[#ff5a1f] text-2xl font-bold animate-pulse">:</span>
      <TimeBlock value={formatNumber(timeLeft.minutes)} label="MIN" />
      <span className="text-[#ff5a1f] text-2xl font-bold animate-pulse">:</span>
      <TimeBlock value={formatNumber(timeLeft.seconds)} label="SEC" />
    </div>
  );
}

function TimeBlock({ value, label }) {
  return (
    <div className="text-center">
      <div className="bg-[#121212] border border-[#333] px-4 py-3 min-w-[70px]">
        <span className="font-mono text-3xl font-bold text-white">{value}</span>
      </div>
      <span className="text-[#555] text-[10px] uppercase tracking-wider mt-1 block">{label}</span>
    </div>
  );
}
